import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/site/LandingPage";
import SupportPage from "./components/site/SupportPage";
import DailyApp from "./DailyApp";

// Top-level router:
//   /            → MintLab public landing page (i18n, no auth)
//   /support     → "Submit an issue" form (embeddable in apps, no auth)
//   /app/*       → the "1% Better Everyday" daily app (auth, PWA)
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/app/*" element={<DailyApp />} />
      {/* Legacy deep links from the old single-app setup → keep them working */}
      <Route path="/history" element={<Navigate to="/app/history" replace />} />
      <Route path="/community" element={<Navigate to="/app/community" replace />} />
      <Route path="/feedback" element={<Navigate to="/app/feedback" replace />} />
      <Route path="/profile" element={<Navigate to="/app/profile" replace />} />
      <Route path="/admin/*" element={<Navigate to="/app/admin" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
